import { ActivatedRoute } from '@angular/router';

/** Lee `moduleId` de la ruta `prior-appointment/m/:moduleId` (propaga por padres). */
export function communityModuleIdFromRoute(route: ActivatedRoute): number | null {
  let r: ActivatedRoute | null = route;
  while (r) {
    const raw = r.snapshot.paramMap.get('moduleId');
    if (raw != null && raw !== '') {
      const n = Number(raw);
      return Number.isFinite(n) && !Number.isNaN(n) ? n : null;
    }
    r = r.parent;
  }
  return null;
}

/** Base path relativo a la comunidad para el flujo de reservas de un módulo. */
export function priorAppointmentModuleBasePath(communityCode: string, moduleId: number): string {
  return `${communityCode}/prior-appointment/m/${moduleId}`;
}
